import { C1Chip } from 'c1ui/components/C1Chip'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ThumbsDown, ThumbsUp } from 'lucide-react'
import { UIMessageFeedback, UIMessageFeedback_Sentiment } from 'pbts/c1/api/conversations/v1/conversations'
import { FC } from 'react'

type ViewMessageFeedbackProps = {
    feedback: UIMessageFeedback
}

export const ViewMessageFeedback: FC<ViewMessageFeedbackProps> = ({ feedback }) => {
    let sentimentIcon: React.ReactNode
    switch (feedback.sentiment) {
        case UIMessageFeedback_Sentiment.POSITIVE:
            sentimentIcon = <C1Icon icon={ThumbsUp} sx={{ color: 'success.main' }} />
            break
        case UIMessageFeedback_Sentiment.NEGATIVE:
            sentimentIcon = <C1Icon icon={ThumbsDown} sx={{ color: 'error.main' }} />
            break
        default:
            // This should not happen lets not display anything
            return null
    }
    return (
        <C1Chip
            label={feedback.text}
            icon={sentimentIcon}
            color={feedback.sentiment === UIMessageFeedback_Sentiment.POSITIVE ? 'success' : 'error'}
            sx={{
                mt: 2,
                p: 2,
                gap: 1,
                width: 'fit-content',
            }}
        />
    )
}
